module.exports = __webpack_public_path__ + "img/a-banner2.fa7fda69.png";